import * as React from 'react'
import { Grid } from 'semantic-ui-react'
import styled from 'styled-components'

import { FormField } from '../shared/reactForm'

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  .input-wrapper {
    width: calc(100% - 30px);
    position: relative;
    .icon-container {
      display: flex;
      position: absolute;
      right: 7px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`

export const ChangePasswordField = (props) => {
  const { label, form, type, name, rightSideElement, inputIcon, ...rest } = props
  return (
    <Grid.Row>
      <Grid.Column width={6} className="u-flex u-alignCenter align-right">
        {label}
      </Grid.Column>

      <Grid.Column width={8}>
        <Wrapper>
          <div className="input-wrapper">
            <FormField form={form} type={type} name={name} autoComplete="off" {...rest} />
            <div className="icon-container">{inputIcon}</div>
          </div>
          {rightSideElement}
        </Wrapper>
      </Grid.Column>
    </Grid.Row>
  )
}
